import React from 'react';
import t from 'babel-plugin-yate/macro';
import Dropdown from '../Dropdown';

function User(props) {
  const { user, logOut } = props;

  return (
    <Dropdown
      id="UserDropdown"
      trigger={
        <div className="pr-3 pl-2 flex items-center">
          <div className="bg-grey-1 w-8 h-8 flex text-center rounded-full text-white content-center justify-center items-center">
            <div>{`${user.first_name
            .charAt(0)
            .toUpperCase()}${user.last_name
            .charAt(0)
            .toUpperCase()}`}</div>
          </div>
          <div className="py-3 px-4 pl-2">
            {user.first_name} {user.last_name}
          </div>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-grey-darker-3">
            <svg
              className="fill-current inline h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      }
      align="right"
    >
      <ul className="list-reset whitespace-no-wrap">
        <li>
          <button
            onClick={logOut}
            className="focus:outline-none focus:bg-grey-2 px-2 py-2 block w-full text-left text-black hover:bg-grey-4"
          >{t`Logout`}</button>
        </li>
      </ul>
    </Dropdown>
  )
}

export default User;
